import { render, staticRenderFns } from "./CandidatesCanceled.vue?vue&type=template&id=565f0af8&lang=pug&"
import script from "./CandidatesCanceled.vue?vue&type=script&lang=js&"
export * from "./CandidatesCanceled.vue?vue&type=script&lang=js&"
import style0 from "./CandidatesCanceled.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
installComponents(component, {VBtn})
